import React, { useState } from 'react';
import { useTranslation} from "react-i18next";
import { connect, useDispatch } from 'react-redux';
import { InputText } from 'primereact/inputtext'
import { InputTextarea } from 'primereact/inputtextarea';
import { Button } from 'primereact/button';
import { Message } from 'primereact/message';
import { InputSwitch } from 'primereact/inputswitch';
import { Dialog } from 'primereact/dialog';

import { getViewerSessionConfig } from '../model/MapModel';


function SaveViewerWidget({ auth, core, type, viewer }) {

  const { utils } = core;
  const { getWindowSize, showOnPortal } = utils;

  const [showForm, setShowForm] = useState(false);
  const [id, setId] = useState(null);
  const [name, setName] = useState('');
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [is_active, setIsActive] = useState(true);
  const [allow_add_layers, setAllowAddLayers] = useState(true);
  const [allow_user_session, setAllowUserSession] = useState(false);
  const [allow_anonymous, setAllowAnonymous] = useState(true);

  const { t } = useTranslation();

  const wsize = getWindowSize();
  const isMobile = wsize[0] <= 768;
  
  // Enable redux actions
  const dispatch = useDispatch();
  const { viewer_save_record, viewer_add_notification } = core.actions;

  function openForm() {
    setId(viewer.id);
    setName(viewer.name);
    setTitle(viewer.title);
    setDescription(viewer.description);
    setIsActive(viewer.is_active === null ? true : viewer.is_active);
    setAllowAddLayers(viewer.allow_add_layers);
    setAllowUserSession(viewer.allow_user_session == null ? false : viewer.allow_user_session);
    setAllowAnonymous(viewer.allow_anonymous == null ? true : viewer.allow_anonymous);
    setShowForm(true);
  }
  
  // Render user
  if (!auth?.data?.token || !viewer.is_owner) return null;

  function submit(e) {
    e.preventDefault();

    if (!name || name.length==0 || !title || title.length==0) {
      return false;
    }

    //Get current session viewer config
    const newconfig = getViewerSessionConfig(viewer);

    const record = {
      id,
      name,
      title,
      description,
      is_active,
      allow_add_layers,
      allow_user_session,
      allow_anonymous,
      config_json: JSON.stringify(newconfig)
    }
    dispatch(viewer_save_record(core, record, null, null, (res) => {
      if (res?.success) {
        const msg = {
          severity: "success",
          summary: t("saveMap","Gravar mapa"),
          detail: `${t("successActionMsg", "Operação realizada com sucesso")}.`
        }
        dispatch(viewer_add_notification({group: "viewer", message: msg}));
      }
    }));
  }

  // Render save button
  return (
    <React.Fragment>
      { type != 'menu' ? 
      <button className="p-link" onClick={e => openForm()}>
        <span className="layout-topbar-item-text">{t("save", "Gravar")}</span>
        <span className="layout-topbar-icon pi pi-save"/>
      </button> :
        <a href="#" className="p-menuitem-link" role="menuitem" tabIndex="0" onClick={e => {e.preventDefault(); openForm();}} >
          <span className="p-menuitem-icon pi pi-save"></span><span className="p-menuitem-text">{t("save", "Gravar")}</span>
        </a> }

      {showOnPortal(<Dialog
        header={t("saveMap", "Gravar mapa")}
        visible={showForm}
        style={{width: isMobile ? '90%' : '35vw' }} 
        modal 
        onHide={e => setShowForm(false)}>

          <form onSubmit={e => submit()}>

            <div className="p-fluid">

              <div className="grid field">
                <label className="col-12 md:col-4">{t("name", "Nome")}</label>
                <div className="col-12 md:col-8">
                  <InputText
                    className={(!name || name.length == 0 ? 'p-invalid' : '')}
                    value={name}
                    placeholder="Nome do Visualizador"
                    onChange={e => setName(e.target.value)}
                  />
                  { (!name || name.length == 0) &&
                  <small className="p-error block">{t("requiredField", "Campo de preenchimento obrigatório")}</small> }                  
                </div>
              </div>

              <div className="grid field">
                <label className="col-12 md:col-4">{t("title", "Título")}</label>
                <div className="col-12 md:col-8">
                  <InputText
                    className={(!title || title.length == 0 ? 'p-invalid' : '')}
                    value={title}
                    placeholder={t("title", "Título")}
                    onChange={e => setTitle(e.target.value)}
                  />
                  { (!title || title.length == 0) &&
                  <small className="p-error block">{t("requiredField", "Campo de preenchimento obrigatório")}</small> }                  
                </div>
              </div>

              <div className="grid field">
                <label className="col-12 md:col-4">{t("description", "Descrição")}</label>
                <div className="col-12 md:col-8">
                  <InputTextarea rows={3}
                    value={description}
                    placeholder={t("description", "Descrição")}
                    onChange={e => setDescription(e.target.value)}
                  />
                </div>
              </div>              

              <div className="grid field">
                <label className="col-12 md:col-4">{t("isActive", "Está ativo")}?</label>
                <div className="col-12 md:col-8">
                  <InputSwitch
                    checked={is_active}
                    onChange={(e) => setIsActive(!is_active)}
                  />
                </div>
              </div>

              <div className="grid field">
                <label className="col-12 md:col-4">{t("allowSaveSession", "Permitir gravar sessão")}?</label>
                <div className="col-12 md:col-8">
                  <InputSwitch
                    checked={allow_user_session}
                    onChange={(e) => setAllowUserSession(!allow_user_session)}
                  />
                </div>
              </div>

              <div className="grid field">
                <label className="col-12 md:col-4">{t("allowAnonymousAccess", "Permitir acesso anónimo")}?</label>
                <div className="col-12 md:col-8">
                  <InputSwitch
                    checked={allow_anonymous}
                    onChange={(e) => setAllowAnonymous(!allow_anonymous)}
                  />
                </div>
              </div>              

            </div>

            <div className="p-dialog-myfooter">
              <Button 
                color='green'
                icon={ viewer.save_loading ? "pi pi-spin pi-spinner": "pi pi-check" }
                label={t("save", "Gravar")} 
                onClick={submit}
                disabled={(viewer.save_loading)}
              />
            </div>

            { viewer.save_error &&
              <div className="p-fluid"> 
                <Message severity="error" text={t("unavailableService", "Serviço Indisponível")}></Message>
              </div>
            }

            { viewer.save_response && !!viewer.save_response.message &&
              <div className="p-fluid">
                <Message severity="error" text={t("unexpectedError", "Ocorreu um erro inesperado")}></Message>
              </div>
            }

          </form>
      </Dialog>)}

    </React.Fragment>
  )
}

export default connect(state => ({ auth: state.root.auth, viewer: state.root.viewer }))(SaveViewerWidget)